var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelopeBitcoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MicrosoftOutlookLogo",
    clipPath: "url(#clip0_975_28086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M81.245 43.4587H24.2253C21.601 43.4587 19.4736 45.5861 19.4736 48.2104V105.23C19.4736 107.854 21.601 109.982 24.2253 109.982H81.245C83.8692 109.982 85.9966 107.854 85.9966 105.23V48.2104C85.9966 45.5861 83.8692 43.4587 81.245 43.4587Z",
    stroke: "#007AFF",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M41.5117 63.3918H44.3174",
    stroke: "#007AFF",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M41.5117 90.0464H44.3174",
    stroke: "#007AFF",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M47.123 63.3921V59.1836",
    stroke: "#007AFF",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M54.3281 63.3921V59.1836",
    stroke: "#007AFF",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M47.123 94.2549V90.0464",
    stroke: "#007AFF",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M54.3281 94.2549V90.0464",
    stroke: "#007AFF",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M44.3174 76.0174H56.9429C58.8032 76.0174 60.5872 76.7563 61.9027 78.0718C63.2181 79.3872 63.9571 81.1713 63.9571 83.0315C63.9571 84.8918 63.2181 86.6759 61.9027 87.9913C60.5872 89.3067 58.8032 90.0457 56.9429 90.0457H44.3174V63.3918H54.8386C56.5129 63.3918 58.1186 64.0569 59.3024 65.2408C60.4863 66.4247 61.1514 68.0304 61.1514 69.7046C61.1514 71.3788 60.4863 72.9845 59.3024 74.1684C58.1186 75.3523 56.5129 76.0174 54.8386 76.0174",
    stroke: "#007AFF",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M119.258 67.2166H128.761C130.021 67.2166 131.23 67.7172 132.121 68.6083C133.012 69.4994 133.513 70.708 133.513 71.9682V124.236C133.513 125.496 133.012 126.705 132.121 127.596C131.23 128.487 130.021 128.988 128.761 128.988H52.735C51.4748 128.988 50.2662 128.487 49.3751 127.596C48.484 126.705 47.9834 125.496 47.9834 124.236V109.981",
    stroke: "#007AFF",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M62.2383 43.458V29.2031C62.2383 27.9428 62.7389 26.7342 63.63 25.8431C64.5211 24.952 65.7297 24.4514 66.9899 24.4514H114.506C115.767 24.4514 116.975 24.952 117.866 25.8431C118.757 26.7342 119.258 27.9428 119.258 29.2031V77.5094",
    stroke: "#007AFF",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M131.885 127.81L85.9961 94.6677",
    stroke: "#007AFF",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M131.885 68.3909L90.748 98.1005",
    stroke: "#007AFF",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_975_28086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 152.052,
    height: 152.052,
    fill: "white",
    transform: "translate(0.466797 0.693359)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeBitcoin);
export default __webpack_public_path__ + "static/media/envelope-bitcoin.6e600c4b52ad14a50fca0f8e3ac90361.svg";
export { ForwardRef as ReactComponent };